import React from "react";
import { Modal, ModalBody } from "../../../../shared/components/modal";
import TicketStatus from "../../../../shared/enums/TicketStatus";
import { isRegRejected, isTicketStatusRejected } from "../../utils";
import { useRegDetail } from "../../../../shared/context/regDetail";
import { useCopies } from "../../../../shared/hooks/useCopies";
import Button from "../../../../shared/components/button";
import { RegistrationRoute } from "../../routes/route";
import { useNavigate } from "react-router-dom";
import Icon from "assets/icons";
import RegistrationStatus from "../../../../shared/enums/RegistrationStatus";
import { getUrlForHref } from "../../../../shared/utils";

export default function TicketRejectInfoModal(props: {
  ticketStatus: TicketStatus;
  registrationStatus: RegistrationStatus;
}) {
  const { helpdeskEmail, marketingUrl } = useRegDetail();
  const copies = useCopies();
  const navigate = useNavigate();
  const isTicketOrRegRejected = React.useMemo(() => {
    return isRegRejected(props.registrationStatus) || isTicketStatusRejected(props.ticketStatus);
  }, [props.ticketStatus, props.registrationStatus]);

  const buyTicketHandler = React.useCallback(() => {
    if (marketingUrl) {
      window.location.href = getUrlForHref(marketingUrl);
    } else {
      navigate(RegistrationRoute.Home, { replace: true });
    }
  }, [navigate, marketingUrl]);

  if (!isTicketOrRegRejected) {
    return null;
  }

  return (
    <React.Fragment>
      <Modal className="ticketRejectModal">
        <ModalBody>
          <Icon.ExclamationMarkSlim />
          <h3>{copies.get("invalid.ticket.status")}</h3>
          <p
            dangerouslySetInnerHTML={{
              __html: copies.get("registration.reject.message", { 0: helpdeskEmail, 1: helpdeskEmail })
            }}
          />
          <Button label={copies.get("view.available.tickets")} isOutline onClick={buyTicketHandler} />
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}
